import { render, staticRenderFns } from "./Numbox.vue?vue&type=template&id=00a37d58&scoped=true&"
import script from "./Numbox.vue?vue&type=script&lang=js&"
export * from "./Numbox.vue?vue&type=script&lang=js&"
import style0 from "./Numbox.vue?vue&type=style&index=0&id=00a37d58&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a37d58",
  null
  
)

export default component.exports